import { AnthropicProvider } from './anthropic';
import { OpenAIProvider } from './openai';
import { GeminiProvider } from './gemini';
import { SystemProvider } from './system';

export { SystemProvider };

export const PROVIDERS = {
  system: {
    name: 'LEARNATLAS AI',
    class: SystemProvider,
    icon: '🧠',
    models: [{ id: 'claude-haiku-4-5-20251001', name: 'Claude Haiku (sistema)' }]
  },
  anthropic: {
    name: 'Anthropic Claude',
    class: AnthropicProvider,
    icon: '🧠',
    placeholder: 'sk-ant-...',
    docUrl: 'https://console.anthropic.com/',
    models: [
      { id: 'claude-sonnet-4-20250514', name: 'Claude Sonnet 4 (Latest)' },
      { id: 'claude-3-5-sonnet-20241022', name: 'Claude 3.5 Sonnet' },
      { id: 'claude-3-opus-20240229', name: 'Claude 3 Opus' }
    ]
  },
  openai: {
    name: 'OpenAI GPT',
    class: OpenAIProvider,
    icon: '🤖',
    placeholder: 'sk-...',
    docUrl: 'https://platform.openai.com/api-keys',
    models: [
      { id: 'gpt-4o', name: 'GPT-4o (Recommended)' },
      { id: 'gpt-4-turbo', name: 'GPT-4 Turbo' },
      { id: 'gpt-4', name: 'GPT-4' },
      { id: 'gpt-3.5-turbo', name: 'GPT-3.5 Turbo' }
    ]
  },
  gemini: {
    name: 'Google Gemini',
    class: GeminiProvider,
    icon: '✨',
    placeholder: 'AIza...',
    docUrl: 'https://aistudio.google.com/app/apikey',
    models: [
      { id: 'gemini-2.0-flash-exp', name: 'Gemini 2.0 Flash (Experimental)' },
      { id: 'gemini-1.5-pro', name: 'Gemini 1.5 Pro' },
      { id: 'gemini-1.5-flash', name: 'Gemini 1.5 Flash' }
    ]
  }
};

export function createProvider(providerType, apiKey, config = {}) {
  const provider = PROVIDERS[providerType];
  if (!provider) {
    throw new Error(`Provider "${providerType}" non supportato`);
  }
  return new provider.class(apiKey, config);
}

export function getProvidersList() {
  return Object.entries(PROVIDERS).map(([id, info]) => ({
    id,
    name: info.name,
    icon: info.icon,
    docUrl: info.docUrl
  }));
}
